export default {
  '/businessday/init': '営業日設定',
  '/businesshour/init': '営業時間設定',
  '/table/order': 'テーブル並べ替え',
  '/synchronize/order': '予約受付優先度設定',
  '/layout/option': 'レイアウト表示設定',
  '/staff/order': 'スタッフの並べ替え',
  '/tag/order': '予約タグ並べ替え',
  '/attribute/order': 'お客様特徴並べ替え',
  '/coursemenu/order': 'コースの並べ替え',
  '/reserve/course': 'コース表示設定',
  '/layout/edit': 'テーブルレイアウト編集',
  '/setting/customer/option/order': '顧客情報項目の並べ替え',
  '/reserve/reception/time': '予約受付設定',
  '/reserve/reception/time/new': '予約受付設定',
  '/reserve/reception/group/edit': '予約受付テーブル設定',
  '/synchronize/edit': '予約受付設定',
  '/reserve/reception/group/order': '予約受付テーブル優先度',
  '/manage/ivr/order': '予約受付パターン優先度',
  '/manage/ivr/edit': '予約受付パターン',
}
